export const getTableSelectionLabel = (selection: any) => {
  if (!selection) return 'Table Selection'

  const { rowCount, columnCount, rowLabels, columnLabels } = selection

  if (rowCount === 1 && columnCount === 1) {
    return `${rowLabels?.[0] || 'Row'} - ${columnLabels?.[0] || 'Column'}`
  } else if (rowCount === 1) {
    return `${rowLabels?.[0] || 'Row'} (${columnCount} cols)`
  } else if (columnCount === 1) {
    return `${columnLabels?.[0] || 'Column'} (${rowCount} rows)`
  } else {
    return `${rowCount}×${columnCount} selection`
  }
}

// Labels resolution, might be scrapped entirely
export const getRevenueAnalysisDescription = (type: string): string => {
  switch (type) {
    case 'current-month':
      return 'Analysis of current month revenue performance'
    case 'ytd':
      return 'Year-to-date revenue analysis and trends'
    case 'waterfall':
      return 'Current revenue waterfall view and data'
    case 'all':
      return 'Comprehensive revenue recognition data analysis'
    default:
      return 'Revenue recognition analysis'
  }
}
